import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineDescription } from "react-icons/md";
import NoData from "@Components/NoData/NoData";
import GiftcardHtml from "src/Modules/GiftCards/pages/GiftcardDetails/components/GiftcardHtml/GiftcardHtml";

type Props = {
  termsAndCondition: string;
};

const TermsAndConditionsWeb: FC<Props> = ({ termsAndCondition }) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col rounded-xs bg-background-default shadow-sm">
      <div className="flex items-center gap-3 border-b border-border-subtle px-5 py-4 font-semibold">
        <div className="bg-background-primary-lighter text-icon-active flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
          <MdOutlineDescription className="h-5 w-5" />
        </div>
        <span className="text-font-default">{t("UserHistory.giftcard.termsAndConditions")}</span>
      </div>
      <div className="w-full px-3 py-2 text-start">
        {termsAndCondition ? (
          <GiftcardHtml className="text-font-default flex flex-col gap-2 p-2 text-xs" html={termsAndCondition} />
        ) : (
          <NoData description={t("UserHistory.giftcard.noTermsAndConditions")} />
        )}
      </div>
    </div>
  );
};

export default TermsAndConditionsWeb;
